module.exports = __webpack_public_path__ + "img/foodfy.0a1c0fb0.webp";